import request from "@/modules/request";

export default class Associate {
  constructor() {}

  static async login(ctx) {
    const results = await request
      .callInternal({
        method: "post",
        route: "/api/admin/login",
        data: ctx,
      })
      .catch((error) => {
        throw error;
      });

    if (results) {
      localStorage.setItem("token", results.data.token);
    }

    return results;
  }

  static async getInvitedUser(token) {
    return request
      .callInternal({
        method: "get",
        route: `/api/admin/retrieveassociateinvite/${token}`,
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        throw error;
      });
  }

  static async completeSignup(user) {
    return request
      .callInternal({
        method: "post",
        route: "/api/admin/signup",
        data: user,
      })
      .then((res) => {
        return res.data.token;
      })
      .catch((error) => {
        throw error;
      });
  }
}
